import Vue from 'vue';
import Router from 'vue-router';
import Vip from '@/components/index';
import Paid from '@/components/paid';
import Right from '@/components/right';
import Bonus from '@/components/bonus';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Vip',
      component: Vip,
      meta: {
        title: '会员中心',
        keepAlive: true
      }
    },
    {
      path: '/paid',
      name: 'Paid',
      component: Paid,
      meta: {
        title: '支付结果',
        keepAlive: true
      }
    },
    {
      path: '/right',
      name: 'Right',
      component: Right,
      meta: {
        title: '会员特权',
        keepAlive: true
      }
    },
    {
      path: '/bonus',
      name: 'Bonus',
      component: Bonus,
      meta: {
        title: '福利领取',
        keepAlive: true
      }
    }
  ]
});
